/** Skeleton placeholder blocks for loading states */

function Bone({ className = '' }: { className?: string }) {
  return (
    <div
      className={`animate-pulse rounded bg-gray-200 dark:bg-gray-700 ${className}`}
    />
  );
}

/** A single chat-message-shaped skeleton row */
export function MessageSkeleton() {
  return (
    <div className="flex gap-3 px-3 py-3 sm:px-4">
      <Bone className="h-8 w-8 flex-shrink-0 rounded-full sm:h-10 sm:w-10" />
      <div className="flex-1 space-y-2">
        <div className="flex items-center gap-2">
          <Bone className="h-3 w-24" />
          <Bone className="h-3 w-12" />
        </div>
        <Bone className="h-3 w-full" />
        <Bone className="h-3 w-3/4" />
      </div>
    </div>
  );
}

/** Multiple message skeletons */
export function MessageListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="divide-y divide-gray-100 dark:divide-gray-800">
      {Array.from({ length: count }, (_, i) => (
        <MessageSkeleton key={i} />
      ))}
    </div>
  );
}

/** A list-item skeleton (inbox, bookmarks, search results) */
export function ListItemSkeleton() {
  return (
    <div className="flex items-center gap-3 px-3 py-3 sm:px-4">
      <Bone className="h-9 w-9 flex-shrink-0 rounded-full" />
      <div className="flex-1 space-y-2">
        <Bone className="h-3 w-32" />
        <Bone className="h-3 w-48" />
      </div>
      <Bone className="h-3 w-10" />
    </div>
  );
}

/** Multiple list-item skeletons */
export function ListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="divide-y divide-gray-100 dark:divide-gray-800">
      {Array.from({ length: count }, (_, i) => (
        <ListItemSkeleton key={i} />
      ))}
    </div>
  );
}

/** Card skeleton for scheduled messages, groups, etc */
export function CardSkeleton() {
  return (
    <div className="rounded-lg border border-gray-200 p-4 dark:border-gray-700">
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <Bone className="h-4 w-32" />
          <Bone className="h-4 w-16" />
        </div>
        <Bone className="h-3 w-full" />
        <Bone className="h-3 w-2/3" />
      </div>
    </div>
  );
}

export function CardListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }, (_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}
